import React, { useRef, useState } from 'react'
import { KeyboardArrowDownRounded, faqs } from '../../utils/constants'

import './faq.css'

interface FaqItem {
  id: string | number;
  header: string;
  text: string;
}

interface AccordionItemProps {
  handleToggle: (index: string | number) => void;
  active: string | number | null;
  faq: FaqItem;
}

const AccordionItem = ({ handleToggle, active, faq }: AccordionItemProps) => {
    const contentEl                     = useRef<HTMLDivElement>(null)
    const { header, id, text }          = faq
  
    return (
      <>
        <div className={active === id ? "faq-header active" : "faq-header"} onClick={() => handleToggle(id)}>
          <h2>{header}</h2>
          <span><KeyboardArrowDownRounded /></span>
        </div>
  
        <div
         ref={contentEl} 
         className={`faq-collapse ${active === id ? "show" : ""}`} 
         style={{
          height: active === id && contentEl.current
            ? `${contentEl.current.scrollHeight}px`
            : "0px",
          }}>
            <p>{text}</p>
        </div>
      </>
    )
  }
  
  const Faq = () => {
    const [active, setActive] = useState<string | number | null>(null)
  
    const handleToggle = (index: string | number) => {
      if(active === index){
        setActive(null)
      }else{
        setActive(index)
      }
    }
  
    return (
      <>
        <title>Frequently asked questions</title>
        <div className='faq-section-wrapper'>
            {/* <SubHeaders pageTitle="Frequently asked questions" headerText="Find answers to commonly asked questions, and your submit requests to us and get a feedback in 24 hours" /> */}

            <article className='faq-container'>
              {faqs.map((faq, index) => {
                return(
                  <AccordionItem 
                    key={index}
                    active={active}
                    handleToggle={handleToggle}
                    faq={faq}
                  />
                )
              })}
            </article>
        </div>
      </>
    )
  }

export default Faq